export const canSeeShiftManagement = (authData) => {
  const admin = authData?.admin;
  if (!admin) return false;
  if (!admin.is_restricted) return true;
  return admin.permissions?.leaves?.edit === true;
};
